import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums'

@Injectable({
  providedIn: 'root'
})
export class DocumentiService extends BaseService {
  /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
  constructor(http: Http) {
    super(http);
  }

  getAllDocumenti(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doGet('assets/listDocumenti.json', null, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('documento/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * full text search method
   * @param reqBuilder data
   */
  fullTextSearch(reqBuilder: RequestBuilder): Observable<any> {
    //return this.doGet('assets/listDocumenti.json', null, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    return this.doPost('ricerca/fullText', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * show PDF
   * @param reqBuilder 
   */
  showPDF(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('documento/visualizza', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * save questions of storicoModulo for Document
   * @param reqBuilder 
   */
  saveStoricoModulo(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('storicoModulo/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * upload file
   * @param file file upload
   * @param numeroAllegato number of allegato
   * @param storicoModuloId id of storico modulo
   * @param nomeFile name of file
   */
  uploadAllegato(file: any, numeroAllegato: string, storicoModuloId: string, nomeFile: string): Observable<any> {
    return this.doUpload('allegato/save', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_OCTET_STREAM, nomeFile, numeroAllegato, storicoModuloId)
  }

  /**
   * visualizza allegato
   * @param reqBuilder 
   */
  visualizzaAllegato(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/visualizza', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * delete allegato
   * @param reqBuilder 
   */
  deleteAllegato(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/delete', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * visualizza allegato pagamenti
   * @param reqBuilder 
   */
  visualizzaPagamentoCommessa(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/visualizzaPagamentoCommessa', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * visualizza allegato SAL
   * @param reqBuilder 
   */
  visualizzaSAL(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/visualizzaSAL', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * visualizza allegato SAL Commessa
   * @param reqBuilder 
   */
  visualizzaSALCommessa(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/visualizzaSALCommessa', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
  /**
   * visualizza allegato pagamenti attivita
   * @param reqBuilder 
   */
  visualizzaPagamentoAttivita(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/visualizzaPagamentoAttivita', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * visualizza allegato SAL attivita
   * @param reqBuilder 
   */
  visualizzaSALAttivita(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/visualizzaSALContratto', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
     * check su stato documento
     * @param reqBuilder 
     */
  checkStatus(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('documento/checkStatus', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * full text search method
   * @param reqBuilder data
   */
  fetchVariazioni(reqBuilder: RequestBuilder): Observable<any> {
    //return this.doGet('assets/listDocumenti.json', null, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    return this.doPost('variazioni/fetch', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
    * save scadenza for allegato
    * @param reqBuilder 
    */
  saveScadenzaAllegato(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegato/scadenza', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * create new document
   * @param reqBuilder 
   */
  createNewDocumento(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('StoricoModulo/duplica', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * fetch all variazioni risposte
   * @param reqBuilder 
   */
  fetchVariazioniRisposte(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('documento/variazioni', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * save stato antimafia file
   * @param file 
   * @param aziendaId 
   * @param nomeFile 
   * @param statoAntimafia 
   * @param allegatoId
   */
  saveCertificatoAntimafia(file: any, aziendaId: string, nomeFile: string, statoAntimafia: string, allegatoId: number): Observable<any> {
    return this.doUploadStatoAntimafiaAzienda('certificatoAntimafia/save', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON, aziendaId, nomeFile, statoAntimafia, allegatoId)
  }

  /**
   * downlaod certificato antimafia
   * @param reqBuilder 
   */
  downloadCertificatoAntimafia(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('certificatoAntimafia/download', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

}